import ptBrTranslations from './pt-br'
import enUsTranslations from './en-us'
import esTranslations from './es'

export default {
    'pt-BR': ptBrTranslations,
    'en-US': enUsTranslations,
    'es': esTranslations
}